/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/3/16,
 * Refactored by kyang on 9/27/19
 */

function CalendarController(
    this: JS5Object,
    _: JS5Object,
    $filter: JS5Function,
    $location: JS5Object,
    BreadcrumbService: JS5Object,
    SidebarService: JS5Object
) {

    //======//
    // Grid //
    //======//

	this.currentGridOptions = {
		rowHeight: 26,
		columnDefs: this.columnDefs,
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableFullRowSelection: true,
		multiSelect: true,
		enableColumnMenus: false,
		enableSorting: false,
		enableColumnResizing: true,
		enableVerticalScrollbar: 2,
		rowTemplate: 'dashboard/calendars/base/gridTemplates/calendar-row-template.html'
	};

	this.rowDoubleClicked = (row: JS5Object, tab: string) => {
		BreadcrumbService.addBreadcrumb({
			location: '/packages',
			name: 'Packages - Edit',
			params: angular.copy($location.search())
		});
		let url = '';
		if (row.parentPackageId) {
			url = '/packages/package/edit/' + row.parentPackageId + '/liveClip?livePackageId=' + row.packageId;
		}
		else {
			url = '/packages/package/edit/' + row.packageId + (tab || '/metadata');
		}
		SidebarService.goToUrl(url, 'packages', 'calendars');
	};

	const sortKeys = (data: JS5Object) => {
		let keys = Object.keys(data);
		keys.sort((a, b) => {
			let aTime = new Date(a).getTime();
			let bTime = new Date(b).getTime();
			if (isNaN(aTime) && isNaN(bTime)) {
				if (data[a].position < data[b].position) {
					return -1;
				}
				else {
					return 1;
				}
			}
			else if (isNaN(aTime)) {
				return -1;
			}
			else if (isNaN(bTime)) {
				return 1;
			}
			else {
				if (aTime < bTime) {
					return -1;
				}
				else {
					return 1;
				}
			}
		});

		return keys;
	};

	const createGroupings = (data: JS5Object) => {
		let customGridItems: JS5Object[] = [];
		let todayItems: JS5Object[] = [];
		let laterItems: JS5Object[] = [];
		let sortedKeys = sortKeys(data);
		angular.forEach(sortedKeys, (key: string) => {
			let val: JS5Object = data[key];
			let header: JS5Object = {header: true, title: key};
			if (val.data && val.data.length) {
				if (val.style) {
					header.style = val.style;
					customGridItems.push(header);
					customGridItems = customGridItems.concat(val.data);
					header.title = key;
				}
				else {
					let dateKey = new Date(key);
					if (!isNaN(dateKey.getTime())) {
						if (dateKey.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
							header.style = 'today-cal-header';
							todayItems.push(header);
							todayItems = todayItems.concat(val.data);
						}
						else {
							header.style = 'default-cal-header';
							laterItems.push(header);
							laterItems = laterItems.concat(val.data);
						}
						header.title = $filter('amDateFormat')(dateKey, 'dddd MMMM DD, YYYY');
					}
				}
			}
		});
		return _.concat(customGridItems, todayItems, laterItems);
	};


	//=================//
    // Lifecycle Hooks //
    //=================//

	this.$onInit = () => {
	    if (this.gridData) {
            this.currentGridOptions.data = createGroupings(this.gridData);
        }
	    if (this.columnDefs) {
            this.currentGridOptions.columnDefs = this.columnDefs;
        }
    };

    this.$onChanges = (changes: JS5Object) => {
        if (_.get(changes, 'gridData.currentValue')) {
            this.currentGridOptions.data = createGroupings(changes.gridData.currentValue);
        }
        if (_.get(changes, 'columnDefs.currentValue')) {
            this.currentGridOptions.columnDefs = changes.columnDefs.currentValue;
        }
    };

    this.$onDestroy = () => {
        SidebarService.ignoreNavUpdates = false;
    };
}


angular.module('prism-ui.calendars').component(
    'calendar',
    {
        bindings: {
            columnDefs: '=',
            gridData: '=',
            allowRowClick: '=',
            calName: '@'
        },
        controller: CalendarController,
        templateUrl: 'dashboard/calendars/base/calendar-template.html',
    });
